// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"e95c28dd","133":"115038b3","219":"540d4030","519":"846f008d","815":"37d790b3","938":"256908fa"}[chunkId] + ".chunk.js";
};